'use client';
import React from 'react';

import './EventsSlider.css';
import { Globus } from './Globus';
import { useTranslations } from 'next-intl';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselArrow,
} from '@wwe-portal/ui/components/carousel';
import EventsSliderItem from './EventsSliderItem/EventsSliderItem';
import { useGetCalendarEvent } from '../../../../hooks/event/use-get-calendar-event.hook';
import { getTodayPST } from '@wwe-portal/utils/date';
import { ClientOnly } from '../../../../components/common/client-only';
import { useNow } from '../../../../../../../packages/ui/lib/hooks/use-now';

const CurrentDate = () => {
  useNow();
  return (
    <p className="text-text500 ml-2 text-xs">
      {getTodayPST().toFormat('DDD hh:mm a')} (PST)
    </p>
  );
};

function EventsSlider() {
  const { eventsTypes } = useGetCalendarEvent();
  const t = useTranslations();

  return (
    <div className="events-slider-container">
      <div className="flex justify-between">
        <span className="text-text500 mb-[30px] text-base font-medium">
          {`${t('today_s')} ${t('events')}`}
        </span>
        <div className="flex">
          <Globus />
          <ClientOnly>
            <CurrentDate />
          </ClientOnly>
        </div>
      </div>
      {eventsTypes?.onGoingEvents?.length ? (
        <Carousel
          isFlooded
          data-id="calendar-events-swiper"
          className="pb-[60px]"
          opts={{ startIndex: 0, align: 'start', containScroll: 'trimSnaps' }}
        >
          <CarouselContent className="ml-0 mr-0 pl-0 md:mr-0">
            {eventsTypes.onGoingEvents.map((event) => (
              <CarouselItem
                key={event.id}
                className="basis-[80%] px-0 pr-4 sm:basis-1/2 md:basis-[290px]"
                data-carousel-item
              >
                <EventsSliderItem event={event} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselArrow />
        </Carousel>
      ) : null}
    </div>
  );
}

export default EventsSlider;
